export enum AddressFormEnum {
  primary = 'primary',
  secondary = 'secondary',
  seasonal = 'seasonal',
}
